module.exports = __webpack_public_path__ + "media/images/download-63d2ef9b8bfd8e2b39b024b880e461a3.svg";